module.exports = __webpack_public_path__ + "img/handsFull.0eb4bebb.png";